export enum AppRoutesNames {
  authentication = 'authentication',
  dashboard = 'dashboard',
}

export enum AuthenticationRouteNames {
  signIn = 'sign-in',
  forgotPassword = 'forgot-password',
  passwordCode = 'password-code',
  newPassword = 'new-password',
  personalInformation = 'personal-information',
  isBlocked = 'blocked',
  changeDefaultPassword = 'change-default-password',
  confirmAccount = 'confirm-account',
  basicInfo = 'basic-info',
  signUp = 'sign-up',
  adminSignUp = 'admin-signup',
  joinOrganization = 'join-organization',
  register = 'register',
  confirmAccountSingUp = 'confirm-account-sing-up',
  companyInformation = 'company-information',
  organizationInformation = 'organization-information',
  accountInformation = 'account-information',
  pickPlan = 'pick-plan',
  adminInfo = 'admin-info',
  employeeInfo = 'employee-info',
  thankYou = 'thank-you',
}

export enum AdminRouteNames {
  home = 'home',
  approve = 'approve',
  requests = 'requests',
  history = 'history',
  profile = 'profile',
  users = 'users',
  clients = 'clients',
  requestType = 'request-type',
  membership = 'membership',
  company = 'company',
  subscriptions = 'subscriptions',
  changePassword = 'change-password',
}

export enum AdminApprovalRouteNames {
  details = 'details/:id',
}

export enum AdminClientRouteNames {
  clients = '',
  createClients = 'create-client',
  clientDetails = 'client-details/:id',
  addMember = 'add-member/:companyId/:companyName',
  editMember = 'edit-member/:id',
}

export enum AdminMembershipRouteNames {
  membership = '',
  wallet = 'wallet/:id/:subscription/:process',
  addCard = 'add-card/:id/:subscription/:process',
}

export enum AdminUsersRouteNames {
  usersList = '',
  addUsers = 'add-users',
  userDetails = 'user-details/:id',
}

export enum AdminCompanyRouteNames {
  companies = '',
  paymentHistory = 'payment-history/:id',
  details = 'details/:id',
  addCompany = 'add-company',
  memberDetails = 'member-details/:id',
}

export enum UserProfileRouteNames {
  profile = '',
  changePassword = 'change-password',
  changeEmail = 'change-email',
}

export enum UserRequestsRouteNames {
  createRequest = '',
  editRequest = 'details/:id',
}

export enum SuperAdminChangePasswordRouteNames {
  changePassword = '',
}
//   export enum SuperAdminRouteNames {
//     home = '',
//     addCompany = 'add-company',
//     companyDetail = 'company-details/:id',
//   }
